import { withId } from 'react-yandex-metrika';

const gTagId = 'GTM-WV37V38';
const ymIdDefault = 49958389;

export async function yandexEvent(event: any, id: number = ymIdDefault) {
  try {
    const ymById = withId(id);
    ymById('reachGoal', event);
  } catch (error) {
    console.log('ym error', event, error);
  }
}

export function googleEvent(event: string, id: string = gTagId) {
  try {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: event,
        user_id: id,
      });
    } else {
      throw new Error('dataLayer is not defined!');
    }
  } catch (error) {
    console.error('google event error', event, error);
  }
}
